module.exports = __webpack_public_path__ + "img/lang.ecbf9f7f.png";